import styled from "styled-components";
import { colors } from "consts";

export const VideoFile = styled.div`
  padding: 32px;
  background: ${colors.gray200};
  width: 100%;
  margin: 0 0 40px;
`;
